<template>
  <div>
    <div class="fullwidth small-bottom-padding">
      <div class="flex-start hero">
        <h1 v-html="$nippets.bestof.h1 + '<br>' + monthName"></h1>
        <h2 v-html="$nippets.bestof.h2"></h2>
        <div class="flex-spacer">&nbsp;</div>
        <search-widget right v-if="winwidth > 960" />
      </div>
      
    </div>
    <div class="fullwidth no-top-padding">
      <div>
        <div class="hero-images">
          <hero-image v-for="(item, index) in slides" :key="item.image.image_id" v-on:zoom="showZoomPortfolio(index)" :item="item" />
          <div v-for="n in extraImages" :key="'xtra' + n" class="herodiv extra"></div>
        </div>
        <zoom-image :visible="showZoom"
              v-on:prev="zoomImage(-1)" v-on:next="zoomImage(1)"
              :image="selItem.image" v-on:close="closeZoom" :artist="selItem.artist" />
      </div>
      <div class="a-right">
        <top-button />
      </div>
    </div>
  </div>

</template>

<script>
import TopButton from '@/components/buttons/TopButton.vue'
import HeroImage from '@/components/widgets/HeroImageWidget.vue'
import ZoomImage from '@/components/panels/ZoomImage.vue'
import SearchWidget from '@/components/widgets/SearchWidget.vue'
export default {
  components: {
    HeroImage,
    TopButton,
    ZoomImage,
    SearchWidget
  },
  data () {
    return {
      slides: [],
      selItem: {},
      index: 0,
      showZoom: false,
      winwidth: 0
    }
  },
  computed: {
    extraImages () {
      let res = 4 - (this.slides.length % this.columns)
      if(res == 4) {
        res = 0
      }
      return res
    },
    monthName () {
      let dt = new Date()
      return dt.toLocaleString(this.$nippets.ietf, { month: "long" }) + ' ' + dt.getFullYear();
    },
    columns () {
      if(this.winwidth > 1300) {
        return 4
      }
      if(this.winwidth > 960) {
        return 3
      }
      if(this.winwidth > 768) {
        return 2
      }
      return 1
    }
  },
  created () {
    this.init()
    const title = `${this.$nippets.bestof.h1} ${this.monthName}`
    const desc = this.$nippets.bestof.h2
    this.$k.setMetatags(title, desc);
    this.$k.setMeta('og:type', 'article')
    this.$k.setMeta('og:title', title)
    this.$k.setMeta('og:description', desc)
  },
  mounted () {
    this.winwidth = window.innerWidth
    window.addEventListener('resize', this.updateWidth)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateWidth)
  },
  methods: {
    updateWidth() {
      this.winwidth = window.innerWidth
    },
    async init () {
      let res = await this.$apix.get('home/current')
      let items = res.data.filter(el => el.image)
      let arr = []
      for(let item of items) {
        let artist = await this.$store.dispatch('fetchArtist', item.artist)
        if(artist) {
          arr.push({ image: item.image, artist: artist })
        }
      }
      this.slides = arr
    },
    showZoomPortfolio (index) {
      
      this.selItem = this.slides[index]
      this.index = index
      this.showZoom = true
    },
    closeZoom() {
      this.showZoom = false
    },
    zoomImage(dir) {
      let val = this.$k.getCircleValue(this.index + dir, this.slides.length - 1)
      this.showZoomPortfolio(val)
    }
  }
}
</script>

<style>
.hero-images{
  display:flex;
  position:relative;
  justify-content: space-between;
  padding-bottom:1%;
  flex-wrap: wrap;
  width:100%;
  overflow:hidden;
  margin:0;

}

.herodiv.extra{
  background-color:transparent;
}

.flex-start.hero h1{
  width:28%;
  margin-right:10px;
}

.flex-start.hero h2{
  width: 40%;
  margin: 0 20px 0 0;
  color: #71716f;
  font-size: 21px;
  max-width:600px;
}

.flex-spacer{
  flex-grow:1;
}

@media screen and (max-width:960px)
{
  .flex-start.hero{
    display:block;
  }

  .flex-start.hero h1, .flex-start.hero h2
  {
    width:100%;
    margin-right:0;
  }


}
</style>